import React from "react";

import {
	Text,
	Button,
	Modal,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Divider,
	FormControl,
	useToast,
} from "@chakra-ui/react";

import { putReprogramarEvaluacionThunk } from "store/evaluaciones/thunks";
import { useAppDispatch } from "store/store";

interface ModalReprogramarProps {
	codEB?: string;
	isOpen: boolean;
	onClose: () => void;
}

export const ModalReprogramar: React.FC<ModalReprogramarProps> = (props) => {
	const { codEB, isOpen, onClose } = props;
	const [isLoading, setIsLoading] = React.useState(false);
	const dispatch = useAppDispatch();
	const toast = useToast();

	const handleOnClick = async () => {
		setIsLoading(true);
		if (!codEB) return;
		try {
			const res = await dispatch(
				putReprogramarEvaluacionThunk({
					codEB,
				}),
			);

			if (res.meta.requestStatus === "fulfilled") {
				setIsLoading(false);
				toast({
					title: "Visita adelantada",
					description: "La visita ha sido adelantada exitosamente",
					status: "success",
					duration: 5000,
					isClosable: true,
				});
				onClose();
			} else {
				setIsLoading(false);
				toast({
					title: "Error al adelantar visita",
					description: "Ha ocurrido un error al adelantar la visita",
					status: "error",
					duration: 5000,
					isClosable: true,
				});
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="xl">
			<ModalOverlay />
			<ModalContent containerProps={{ pt: "10rem" }}>
				<ModalHeader m=".5rem 0">
					<Text textStyle="body1" color="pink.500">
						Volver al estado de Programada
					</Text>
				</ModalHeader>
				<ModalCloseButton />
				<Divider />
				<FormControl id="reprogramar-evaluacion" mt="1rem">
					<Divider />
					<ModalFooter m=".75rem 0">
						<Button bgColor="gray.400" onClick={onClose} mr={3} w="100%" _hover={{ bg: "gray.500" }}>
							Cancelar
						</Button>
						<Button
							bgColor="pink.500"
							w="100%"
							_hover={{ bg: "pink.600" }}
							onClick={handleOnClick}
							isLoading={isLoading}
							loadingText="Enviando"
						>
							Volver a programada
						</Button>
					</ModalFooter>
				</FormControl>
			</ModalContent>
		</Modal>
	);
};
